const typeScale = num => {
	const RYTHM = 8;
	const result = num * RYTHM;
	return `${result}px`;
};

export default typeScale;
